import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./i18n/config"; // Initialize i18n
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || "";

function hideDevErrorOverlay() {
  if (typeof document === "undefined") return;
  const selectors = [
    "#webpack-dev-server-client-overlay",
    "#react-error-overlay",
    ".react-error-overlay",
    "[data-react-error-overlay]",
  ];
  selectors.forEach((sel) => {
    try {
      const el = document.querySelector(sel);
      if (el) {
        el.style.setProperty("display", "none", "important");
        el.setAttribute("aria-hidden", "true");
      }
    } catch (_) {}
  });
  const bodyChildren = document.body?.children;
  if (bodyChildren) {
    for (let i = 0; i < bodyChildren.length; i++) {
      const node = bodyChildren[i];
      if (node.id === "root") continue;
      if (node.tagName === "SCRIPT" || node.tagName === "NOSCRIPT") continue;
      if (node.tagName === "IFRAME") {
        node.style.setProperty("display", "none", "important");
      }
    }
  }
}

if (typeof document !== "undefined") {
  const observer = new MutationObserver(() => {
    hideDevErrorOverlay();
  });
  observer.observe(document.body, {
    childList: true,
    subtree: false,
  });
  window.addEventListener("error", () => {
    setTimeout(hideDevErrorOverlay, 0);
    setTimeout(hideDevErrorOverlay, 50);
    setTimeout(hideDevErrorOverlay, 200);
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  //<React.StrictMode>
    <HelmetProvider>
      <GoogleReCaptchaProvider
        reCaptchaKey={RECAPTCHA_SITE_KEY}
        scriptProps={{ async: true, defer: true, appendTo: "head" }}
        useEnterprise={false}
        useRecaptchaNet={false}
        container={{
          parameters: { badge: "bottomright" },
        }}
      >
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </GoogleReCaptchaProvider>
    </HelmetProvider>
  //</React.StrictMode>
);
